import { IDemographics } from 'types/IDemographics'
import { IId } from 'types/IId'
import { IScore } from 'types/IScore'
import { ActionType } from 'typesafe-actions'
import { storeReaderAnswers } from './actions'

/** The ultimate combination of all the data we need! */
type Answers = Array<IDemographics & IId & IScore>

export const readerAnswersReducer = (
  state: Answers = [],
  action: ActionType<typeof storeReaderAnswers>
) => {
  if (action.type === storeReaderAnswers.toString()) {
    // reconstruct the array
    return Object.entries(action.payload).map(([id, data]) => ({
      id,
      ...data
    }))
  }

  return state
}

export default readerAnswersReducer
